import getDetail from './getDetail';

// We have the concept of keyDetails the type (an arbitrary number)
// is an old wordpress Id the two id below are for sports
// without legs
const leglessSports = [1001, 1006];

export default ({ information: { sportLabel }, keyDetails }) => {
  if (!keyDetails) {
    return sportLabel;
  }
  const sportDetails = keyDetails.filter((d) =>
    leglessSports.includes(+d.type),
  );
  // See getDetail
  const details = sportDetails
    .map((d) => {
      const detail = getDetail(d.type, d.id);
      if (!detail) return d.value;
      return `${detail} ${d.value}`;
    })
    .join(', ');
  if (sportDetails.length === 1) {
    return details;
  }
  return `${sportLabel}: ${details}`;
};
